var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const regexEscape = /* @__PURE__ */ __name((str) => str.replace(/[\s#$()*+,.?[\\\]^{|}-]/g, "\\$&"), "regexEscape");

export { regexEscape };
//# sourceMappingURL=regex-escape.js.map
